/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { BatchChangeDeliveryStatusDto } from '../../models/batch-change-delivery-status-dto';
import { BatchUpdateResponse } from '../../models/batch-update-response';

export interface DeliveryControllerBatchChangeDeliveryStatus$Params {
      body: BatchChangeDeliveryStatusDto
}

export function deliveryControllerBatchChangeDeliveryStatus(http: HttpClient, rootUrl: string, params: DeliveryControllerBatchChangeDeliveryStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: BatchUpdateResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, deliveryControllerBatchChangeDeliveryStatus.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: BatchUpdateResponse;
      }>;
    })
  );
}

deliveryControllerBatchChangeDeliveryStatus.PATH = '/delivery/batch/change-status';
